import { Brands, CheckoutType, FinancialProducts, VehicleCondition, VehicleType, } from '@volkswagen-onehub/e-commerce-service';
import { readFinance } from '../rethink/utils';
import { useServicesContext } from '../context';
export function getCashPurchasePrice(vehicle) {
    if (!vehicle) {
        return undefined;
    }
    const { typedPrices } = vehicle;
    for (const typedPrice of typedPrices) {
        if (typedPrice.type === 'retail') {
            return typedPrice.amount;
        }
    }
    return undefined;
}
export function getCashCheckout(vehicleBasic) {
    var _a;
    if (!vehicleBasic) {
        return undefined;
    }
    const purchasePrice = getCashPurchasePrice(vehicleBasic);
    if (purchasePrice === undefined) {
        return undefined;
    }
    return {
        brand: Brands.Audi,
        ecommerceCheckoutType: CheckoutType.STOCK_CAR_SALES,
        vehicleIdentifier: vehicleBasic.carId,
        financialProduct: FinancialProducts.CASH,
        vehiclePurchasePrice: `${purchasePrice}`,
        dealerId: vehicleBasic.dealer.id,
        businessModel: (_a = vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.businessModel) === null || _a === void 0 ? void 0 : _a.code,
        vehicleCondition: vehicleBasic.type === 'N' ? VehicleCondition.NEW_CAR : VehicleCondition.USED_CAR,
    };
}
export function getLeanCheckoutPayload(vehicleBasic, webCalcRequest, isFinancing, useFinanceData) {
    var _a;
    if (!vehicleBasic || !webCalcRequest) {
        return undefined;
    }
    const financeRequest = {
        Request: webCalcRequest,
    };
    const financeData = getFinanceDataFromStore(vehicleBasic);
    const productFinancialServices = getFinanceProductIdFromFinanceData(financeData, useFinanceData);
    return {
        brand: Brands.Audi,
        ecommerceCheckoutType: CheckoutType.STOCK_CAR_SALES,
        vehicleIdentifier: vehicleBasic.carId,
        financialProduct: isFinancing ? FinancialProducts.FINANCING : FinancialProducts.RESERVATION,
        dealerId: vehicleBasic.dealer.id,
        businessModel: (_a = vehicleBasic === null || vehicleBasic === void 0 ? void 0 : vehicleBasic.businessModel) === null || _a === void 0 ? void 0 : _a.code,
        productFinancialServices,
        webCalcRequest: financeRequest,
        vehicleType: VehicleType.VTP_CARID,
        vehicleCondition: vehicleBasic.type === 'N' ? VehicleCondition.NEW_CAR : VehicleCondition.USED_CAR,
    };
}
export function isButtonForFinanceProduct(button, financeProductId) {
    const financeProductIds = button.glcFinancingProductIds.split(',').map((item) => item.trim());
    return financeProductIds.indexOf(financeProductId) !== -1;
}
export function isButtonConfiguredForSelectedFinanceProduct(button, financeData, useFinanceData) {
    const currentFinanceProductId = getFinanceProductIdFromFinanceData(financeData, useFinanceData)
        ? getFinanceProductIdFromFinanceData(financeData, useFinanceData)
        : 'PRODUCT_NOT_FOUND';
    if (!currentFinanceProductId ||
        currentFinanceProductId.length === 0 ||
        !button.glcFinancingProductIds) {
        return false;
    }
    return isButtonForFinanceProduct(button, currentFinanceProductId);
}
export function getFinanceDataFromStore(vehicleBasic) {
    if (!vehicleBasic || !vehicleBasic.type) {
        return undefined;
    }
    const storeData = readFinance(vehicleBasic.type);
    if (storeData && (storeData === null || storeData === void 0 ? void 0 : storeData.financing)) {
        return storeData.financing[vehicleBasic.id];
    }
    return undefined;
}
export function isGroupLeanCashCheckoutButton(button) {
    return button && button.type === 'glc-cash-checkout';
}
export function isGroupLeanFinancingCheckoutButton(button) {
    return button && button.type === 'glc-financing-checkout';
}
export function isGroupLeanReservationCheckoutButton(button) {
    return button && button.type === 'glc-reservation';
}
export function isGroupLeanCheckoutButton(button) {
    return (isGroupLeanCashCheckoutButton(button) ||
        isGroupLeanFinancingCheckoutButton(button) ||
        isGroupLeanReservationCheckoutButton(button));
}
export function isFinanceCheckoutButton(button) {
    return button && button.type === 'finance-checkout';
}
export function getLeanCheckoutBackendForButton(button, eCommerceService, vehicle, useFinanceData) {
    let checkoutBackend;
    if (isGroupLeanCheckoutButton(button)) {
        if (isGroupLeanCashCheckoutButton(button)) {
            checkoutBackend = eCommerceService ? getCashCheckout(vehicle) : undefined;
        }
        else {
            const financeData = getFinanceDataFromStore(vehicle);
            if (financeData &&
                isButtonConfiguredForSelectedFinanceProduct(button, financeData, useFinanceData)) {
                checkoutBackend =
                    eCommerceService && financeData && financeData.financeRequestData
                        ? getLeanCheckoutPayload(vehicle, financeData.defaultRequest.Request, isGroupLeanFinancingCheckoutButton(button), useFinanceData)
                        : undefined;
            }
        }
    }
    return checkoutBackend;
}
export function getButtonForProduct(financeProductId) {
    var _a, _b, _c, _d, _e;
    const servicesContext = useServicesContext();
    const audiContentService = servicesContext.getAdditionalService('audi-content-service');
    const configuration = (_c = (_b = (_a = audiContentService.getContent()) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b.vtpConfiguration) === null || _c === void 0 ? void 0 : _c.fields;
    const rawCTAButtons = (_e = (_d = configuration.cta) === null || _d === void 0 ? void 0 : _d.map((button) => button.fields)) !== null && _e !== void 0 ? _e : [];
    for (const button of rawCTAButtons) {
        if (isGroupLeanFinancingCheckoutButton(button) &&
            isButtonForFinanceProduct(button, financeProductId)) {
            return button;
        }
    }
    return undefined;
}
function getProductIdFromProduct(obj) {
    if (obj === null || obj === void 0 ? void 0 : obj.Product) {
        if (obj.Product['@SubType']) {
            return obj.Product['@SubType'];
        }
        if (obj.Product['@ID']) {
            return obj.Product['@ID'];
        }
    }
    return undefined;
}
export function getFinanceProductIdFromFinanceData(financeData, useFinanceData) {
    var _a, _b, _c, _d, _e, _f;
    if (useFinanceData) {
        if ((_b = (_a = financeData === null || financeData === void 0 ? void 0 : financeData.financeResponseData) === null || _a === void 0 ? void 0 : _a.Response) === null || _b === void 0 ? void 0 : _b.Result) {
            const financeResult = (_d = (_c = financeData === null || financeData === void 0 ? void 0 : financeData.financeResponseData) === null || _c === void 0 ? void 0 : _c.Response) === null || _d === void 0 ? void 0 : _d.Result;
            if (Array.isArray(financeResult)) {
                for (const resultEntry of financeResult) {
                    const productId = getProductIdFromProduct(resultEntry);
                    if (productId)
                        return productId;
                }
            }
            else {
                const productId = getProductIdFromProduct(financeResult);
                if (productId)
                    return productId;
            }
            if (((_e = financeData === null || financeData === void 0 ? void 0 : financeData.financeResponseData) === null || _e === void 0 ? void 0 : _e.Response) &&
                financeData.financeResponseData.Response['@ID']) {
                return financeData.financeResponseData.Response['@ID'];
            }
        }
        if ((_f = financeData === null || financeData === void 0 ? void 0 : financeData.financeRequestData) === null || _f === void 0 ? void 0 : _f.Request) {
            const productId = getProductIdFromProduct(financeData.financeRequestData.Request);
            if (productId)
                return productId;
        }
    }
    else if ((financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData) && (financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData['@ID'])) {
        return financeData.defaultProductData['@SubType'] || financeData.defaultProductData['@ID'];
    }
    return undefined;
}
function getProductTypeFromProduct(obj) {
    if (obj === null || obj === void 0 ? void 0 : obj.Product) {
        if (obj.Product['@Type']) {
            return obj.Product['@Type'];
        }
    }
    return undefined;
}
export function getFinanceProductTypeFromFinanceData(financeData, useFinanceData) {
    var _a, _b, _c, _d, _e;
    if (useFinanceData) {
        if ((_b = (_a = financeData === null || financeData === void 0 ? void 0 : financeData.financeResponseData) === null || _a === void 0 ? void 0 : _a.Response) === null || _b === void 0 ? void 0 : _b.Result) {
            const financeResult = (_d = (_c = financeData === null || financeData === void 0 ? void 0 : financeData.financeResponseData) === null || _c === void 0 ? void 0 : _c.Response) === null || _d === void 0 ? void 0 : _d.Result;
            if (Array.isArray(financeResult)) {
                for (const resultEntry of financeResult) {
                    const productId = getProductTypeFromProduct(resultEntry);
                    if (productId)
                        return productId;
                }
            }
            else {
                const productId = getProductTypeFromProduct(financeResult);
                if (productId)
                    return productId;
            }
        }
        if ((_e = financeData === null || financeData === void 0 ? void 0 : financeData.financeRequestData) === null || _e === void 0 ? void 0 : _e.Request) {
            const productId = getProductTypeFromProduct(financeData.financeRequestData.Request);
            if (productId)
                return productId;
        }
    }
    else if ((financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData) && (financeData === null || financeData === void 0 ? void 0 : financeData.defaultProductData['@Type'])) {
        return financeData.defaultProductData['@Type'];
    }
    return undefined;
}
